import {
  Button,
  FormRow,
  Input,
  Modal,
  Spacer,
  Spinner,
  Stack
} from '@efast_public/fjd-component-library';
import { useTranslation } from 'react-i18next';
import { useFitConnectClientInformationUpdate } from '../api/hooks/useFitconnectSenderInformation';
import { useForm } from 'react-hook-form';
import Joi from 'joi';
import { joiResolver } from '@hookform/resolvers/joi';
import { useQuery } from '@tanstack/react-query';
import { ClientInformationDto } from '../api/models/FitConnect/FitConnect';
import { useEffect } from 'react';
import { BehApiRoutes } from '../api/beh-api';

interface UsersAndrolesManagementEditFormProps {
  clientId: string;
  clientSecret: string;
}

interface CreateAndUpdateMandantCredsModalProps {
  readonly onClose: () => void;
  readonly isOpen: boolean;
}

export function CreateAndUpdateMandantCredsModal(
  props: CreateAndUpdateMandantCredsModalProps
) {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();
  const {
    mutateAsync: updateFitConnectClientInformation,
    isPending: isUploading
  } = useFitConnectClientInformationUpdate();
  const { data } = useQuery<ClientInformationDto>({
    queryKey: [BehApiRoutes.fitConnectSenderInformation()]
  });
  const {
    formState: { isValid },
    register,
    handleSubmit,
    reset
  } = useForm<UsersAndrolesManagementEditFormProps>({
    mode: 'onChange',
    defaultValues: {
      clientId: '',
      clientSecret: ''
    },
    resolver: joiResolver(
      Joi.object<UsersAndrolesManagementEditFormProps>({
        clientId: Joi.string().guid().required(),
        clientSecret: Joi.string().required()
      })
    )
  });

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Modal.Header id="CreateAndUpdateMandantCredsModal-header">
        {t('createAndUpdateMandantCredsModal.title')}
      </Modal.Header>

      <Modal.Content>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="descriptionText">
            {t('createAndUpdateMandantCredsModal.subline')}
          </div>
          <Spacer size="s" />
          <Stack spacing="m" direction="column">
            <FormRow
              label={t('createAndUpdateMandantCredsModal.clientId.label')}
            >
              <Input
                id="clientId"
                {...register('clientId')}
                type="text"
                placeholder={t(
                  'createAndUpdateMandantCredsModal.clientId.placeholder'
                )}
              />
            </FormRow>
            <FormRow
              label={t('createAndUpdateMandantCredsModal.clientSecret.label')}
            >
              <Input
                id="clientSecret"
                {...register('clientSecret')}
                enablePasswordToggle
                placeholder={t(
                  'createAndUpdateMandantCredsModal.clientSecret.placeholder'
                )}
                type="password"
              />
            </FormRow>
            {
              <Button
                id={'fitconnectverbinden'}
                variant="primary"
                disabled={!isValid || isUploading}
                onClick={handleSubmit((state) => {
                  updateFitConnectClientInformation(state).catch(() => {});
                })}
              >
                {isUploading ? (
                  <Spinner size="sm" />
                ) : (
                  t('createAndUpdateMandantCredsModal.connect.button')
                )}
              </Button>
            }
          </Stack>
        </form>
      </Modal.Content>
      <Modal.Footer direction="rtl" alignment="none">
        <Button size="sm" variant="secondary-outline" onClick={onClose}>
          {t('globalNotifications.modalAboard')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
